module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/189-equatorial-guinea-5229676c5a5641c74539827a713724c1.svg";